import { render, staticRenderFns } from "./AddClientProvider.vue?vue&type=template&id=aef669ae&"
import script from "./AddClientProvider.vue?vue&type=script&lang=js&"
export * from "./AddClientProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports